import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { logger } from '@sentry/react';
import { router } from './router';

export const App = () => {
  useEffect(() => {
    logger.info('Service Worker controllerchange listener initialized.');
    const handleControllerChange = () => {
      logger.warn(
        'New Service Worker has taken control. Reloading page to apply update and prevent mismatch errors.'
      );
      window.location.reload();
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener(
        'controllerchange',
        handleControllerChange
      );
    }

    return () => {
      if ('serviceWorker' in navigator) {
        logger.info('Cleaning up Service Worker controllerchange listener.');
        navigator.serviceWorker.removeEventListener(
          'controllerchange',
          handleControllerChange
        );
      }
    };
  }, []);

  return <RouterProvider router={router} />;
};
